(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
      this.swiperContainer = null;
      this.swiperSettings = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.products-carousel__slider');

      const swiperNext = this.querySelector('.products-carousel__control-next');
      const swiperPrev = this.querySelector('.products-carousel__control-prev');

      // MISC. EXPRESS — desktop shows ~5.5 cards/view (was 2.75) so the cards
      // match the width of the "What are you looking for?" category tiles and
      // the 4:5 sliders don't render full-screen tall. Mobile unchanged.
      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 5.5,
              spaceBetween: 24,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 5.5,
              spaceBetween: 24,
            },
          },
        },
      };


      if (!swiperContainer) return;

      const useCssMode = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
      const self = this;

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        grabCursor: !useCssMode,
        resistanceRatio: 0.72,
        // Touch: native CSS scroll momentum. Mouse: Swiper free-mode (drag works).
        cssMode: useCssMode,
        freeMode: useCssMode ? false : {
          enabled: true,
          sticky: false,
          momentum: true,
          momentumRatio: 1,
          momentumVelocityRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
        },
        freeModeMomentum: true,
        freeModeMomentumRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: false,
        ...sizeCardSettings[this.cardsSize]
      };

      this.swiperContainer = swiperContainer;
      this.swiperSettings = mainSettings;

      this.swiper = new Swiper(swiperContainer, mainSettings);

      if (useCssMode && this.swiper && this.swiper.wrapperEl) {
        const w = this.swiper.wrapperEl;
        w.style.overflowX = 'auto';
        w.style.overflowY = 'hidden';
        w.style.scrollSnapType = 'none';
        w.style.webkitOverflowScrolling = 'touch';
        w.style.scrollbarWidth = 'none';
        w.style.overscrollBehaviorX = 'contain';
      }
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        if (this.swiper && this.swiper.destroy) this.swiper.destroy(true, true);
      } else {
        if (this.swiperContainer && this.swiperSettings) {
          this.swiper = new Swiper(this.swiperContainer, this.swiperSettings);
        }
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
